import { render, staticRenderFns } from "./AIChat_Banner.vue?vue&type=template&id=1ab8678e&scoped=true"
import script from "./AIChat_Banner.vue?vue&type=script&lang=js"
export * from "./AIChat_Banner.vue?vue&type=script&lang=js"
import style0 from "./AIChat_Banner.vue?vue&type=style&index=0&id=1ab8678e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab8678e",
  null
  
)

export default component.exports